import { useContext } from "react";
import { PeopleContext } from "@shapeable/ui";
import { transformPage, transformPeople } from "../utils/transforms";

export const usePeople = () => useContext(PeopleContext).map(transformPeople);